module.exports = "/_next/static/images/45b2ed5b348df7771a8486136ed6da4d-gift-illustration@0.75x.png.webp";